import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../Firebase_Config/firebase';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './HomomorphicEncryption.css';
//https://web3forms.com/

const GET_EMAIL = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userData = userDocSnapshot.docs[0].data();
        setFormData(prev => ({
          ...prev,
          name: userData.Name || '',
          email: userData.email || ''
        }));
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {
      ...formData,
      access_key: "eeb7e415-06eb-495c-a9f8-075545b91e36"
    };

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(formDataToSend)
    }).then((res) => res.json());

    if (res.success) {
      showToast("Email submitted successfully!", "success");
      setFormData(prev => ({ ...prev, message: '' }));
    } else {
      showToast("Failed to submit. Please try again.", "error");
    }
  };

  return (
    <div className="ContactContainer">
      <h1 className='helptitle'>Contact Form</h1>
      <br/>
      <div className='Hom-card-accent'/>
      
      <form onSubmit={onSubmit}>
        <textarea
          className='OtherInputs'
          name="message"
          placeholder="Write Your Message Here.."
          value={formData.message}
          onChange={handleChange}
        />
        <button className='SubmitInput' type="submit">Submit Form</button>
      </form>

      <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};



const HomomorphicEncryption = () => {
  const [showModal, setShowModal] = useState(true);
  const [hasPaidTrue, setHasPaidTrue] = useState(null);
  const [showContactModal, setShowContactModal] = useState(false);
  
    const getUserId = () => {
      const user = auth.currentUser;
      return user?.uid;
    };
  
    const fetchHasPaidTrue = async () => {
      try {
        const userId = getUserId();
        if (!userId) return;
  
        const userDocQuery = query(collection(db, 'users'), where('userId', '==', userId));
        const userDocSnapshot = await getDocs(userDocQuery);
  
        if (!userDocSnapshot.empty) {
          const userDocData = userDocSnapshot.docs[0].data();
          const getHasPaid = userDocData.HasPaid || false;
          setHasPaidTrue(getHasPaid);
        } else {
          console.log('User document not found');
          setHasPaidTrue(false); // default to false if not found
        }
      } catch (error) {
        console.error('Error fetching payment status:', error);
        setHasPaidTrue(false);
      }
    };
  
    useEffect(() => {
      fetchHasPaidTrue();
    });
  
    const isDisabled = hasPaidTrue === false;
    
  const handleContactClick = () => {
    setShowModal(false);
    setShowContactModal(true);
  };


  return (
    <div className='HomBG'>
      {hasPaidTrue === false && showModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content">
            <button className="close-button" onClick={() => setShowModal(false)}>×</button>
             <button className="contact-button" onClick={handleContactClick}>Contact Us To Get Access</button>
          </div>
        </div>
      )}

      {showContactModal && (
        <div className="Ai-modal-overlay">
          <div className="paid-modal-content contact">
            <button className="close-button" onClick={() => setShowContactModal(false)}>×</button>
            <GET_EMAIL />
          </div>
        </div>
      )}
      <div className='HomMainContent'>
        <div className='Hom-container'>
          <div className='Hom-card-accent'/>
          <br/>
          <img src="Obscura.png" alt="Logo" className='Hom-image' />
          <div className='textContent'>
            {/*<h2 className='headingcenter'>The hub for Collaborative Learning, Zero Data Sharing</h2>
            <p className='textCenter'>A suite of tools for a customised, end-to-end responsible AI experience</p>*/}
            <div className='HomContainer'>
              <div className='Hom2'>
                <div className='Homcolumns'>
                  <h2>What is Obscura?</h2>
                  <p>Obscura is a searchable encryption solution using Homomorphic encryption.  Homomorphic encryption is a form of encryption that enables computations to be performed directly on encrypted data without the need to decrypt it first. The results of these computations, when decrypted, are identical to those that would have been obtained if the operations were performed on the original, unencrypted data. This property allows sensitive information to remain confidential throughout processing, as the data remains encrypted at all times, whether it is being stored, transmitted, or analysed.</p>
                </div>
                <div className='Homcolumns'>
                  <h2>Why Obscura?</h2>
                  <p>This capability is particularly valuable for supporting trusted and responsible AI because it allows organizations to harness the power of AI and machine learning on sensitive datasets—such as medical records, financial information, or personal identifiers—without ever exposing the raw data to internal or external parties. By enabling privacy-preserving analytics and secure data sharing, Obscura helps businesses comply with stringent data protection regulations and fosters user trust. It ensures that even if data is processed in untrusted environments, such as public clouds or by third-party service providers, privacy and confidentiality are maintained, making it a foundational technology for ethical and compliant AI systems.</p>
                </div>
              </div>
              <br />
              {hasPaidTrue && (
                <div className="button-group">
                  <a href="https://fhe.tech.assentian.com/" target="_blank" rel="noopener noreferrer">
                    <button className="download-button" disabled={isDisabled}>
                      Try It Out Here
                    </button>
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomomorphicEncryption;
